import {AsyncPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, OnInit, signal} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {SbbSecondaryButton} from '@sbb-esta/lyne-angular/button';
import {SbbCard} from '@sbb-esta/lyne-angular/card';
import {SbbLoadingIndicator} from '@sbb-esta/lyne-angular/loading-indicator';
import {SbbTitle} from '@sbb-esta/lyne-angular/title';
import {ZkkRollenzuweisungKundeApiModelInternal} from 'cargo-hub-ui-internal-api';
import {firstValueFrom, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ErrorService} from '../../../cd-common/service/error.service';
import {PartnerService} from '../../../services/partner/partner.service';
import {zkkSelectedAction} from '../../auth-store/auth.actions';
import {selectRoleAssignations, selectUser} from '../../auth-store/auth.selectors';

@Component({
  selector: 'app-personal-user-zkk-selection',
  imports: [SbbSecondaryButton, SbbCard, AsyncPipe, SbbLoadingIndicator, SbbTitle],
  templateUrl: './personal-user-zkk-selection.component.html',
  styleUrl: './personal-user-zkk-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalUserZkkSelectionComponent implements OnInit {
  zkkAssignations$: Observable<ZkkRollenzuweisungKundeApiModelInternal[]>;
  loading = signal(false);

  constructor(
    private store: Store,
    private partnerService: PartnerService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.zkkAssignations$ = this.store.pipe(
      select(selectRoleAssignations),
      map(u => u?.rollenzuweisungenKunde ?? [])
    );
  }

  async selectZkk(selectedZkkZuweisung: ZkkRollenzuweisungKundeApiModelInternal): Promise<void> {
    this.loading.set(true);
    try {
      const user = await firstValueFrom(this.store.pipe(select(selectUser)));
      const isSwitch = !!user?.activePartner && user.activePartner.partnerId !== selectedZkkZuweisung.zkk;
      const partnerStammdaten = await firstValueFrom(this.partnerService.getPartnerById(selectedZkkZuweisung.zkk, true));
      this.store.dispatch(zkkSelectedAction({newPartner: partnerStammdaten, isSwitch}));
    } catch (e) {
      this.store.dispatch(this.errorService.getConnectionOrUnknownNotificationErrorAction(e, $localize`:@@ZKK_SELECTION_SERVER_ERROR:Bei der Abfrage der Partner ist ein Fehler aufgetreten.`));
      this.loading.set(false); // when there is no error, we will navigate away (AuthEffects.redirectAfterLoginOrZkkSelection$) and do not want to have the view flicker in between
    }
  }
}
